import { createGlobalStyle } from "styled-components";


const FormStyle = createGlobalStyle`
  //! Global error style
  .globalErrorWrap {
    text-align: center;
    margin-bottom: var(--sp3x);
  }


  *::placeholer {
    color: var(--grey);
  }
  
  //! Calendar 

  .ant-picker-dropdown {
    .ant-picker-panel-container {
      border-radius: 8px;

      .ant-picker-date-panel {
        .ant-picker-header {
          .ant-picker-header-super-prev-btn,
          .ant-picker-header-super-next-btn {
            display: none;
          }

          .ant-picker-header-view {
            font-family: PopSemi;
          }

          button {
            span {
              &:before {
                border-color: var(--black);
              }
            }
          }
        }

        .ant-picker-body {
          .ant-picker-cell-inner {
            font-family: PopReg;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 30px;
            width: 30px;
          }

          .ant-picker-cell-today {
            .ant-picker-cell-inner {
              &:before {
                border: 1px solid var(--purple);
              }
            }
          }

          .ant-picker-cell-selected {
            .ant-picker-cell-inner {
              background-color: var(--purple);
              border-radius: 50%;
            }
          }
        }
      }

      .ant-picker-footer {
        display: none;
      }
    }
  }

  //! Ant Overrides
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    background-color: transparent !important;
    border: 2px solid var(--grey) !important;
  }

  //! Form inputs

  .ant-form-item-label {
    padding: 0 !important;
    line-height: inherit !important;
    margin-bottom: var(--sp3x);

    label {
      font-size: var(--h5);
      font-family: PopSemi;
      width: 100%;
      display: flex;
      justify-content: space-between;

      &:before {
        display: none !important;
      }
    }
  }

  input[type='password'] {
    background-color: transparent;
  }

  //! Datepicker
  .ant-picker {
    width: 100%;
  }

  //! Avatar
  .ant-upload-picture-card-wrapper {
    .ant-upload {
      border: none;
      border-radius: 30px;
      overflow: hidden;
      background-color: #f2f2f2;
      background-image: url('/images/photo.svg');
      background-repeat: no-repeat;
      background-position-x: 50%;
      background-position-y: 50%;
      position: relative;

      &:hover {
        .reload {
          opacity: 1 !important;
        }

        .ant-upload {
          position: relative;

          &:before {
            content:"";
            position: absolute;
            top:0;
            left:0;
            width: 100%;
            height:100%;
            background-color: var(--white);
            opacity:0.5;
          }
        }
      }

      .reload {
        position: absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        transform-origin:center ;
        width: 16px;
        height: 16px;
        opacity: 0;
        pointer-events: none;
        z-index: 5;
        transition: 0.3s;
      }

      & > div {
        opacity: 0;
      }
    }
  }

  //! Select option
  .ant-form-item .ant-select {
    padding:  var(--sp2x) 0;
    border: 2px solid var(--lightGrey);
    border-radius: 12px;
    background: none;
    color: var(--black);
    --webkit-appearance: none;
    font-size: var(--const14);
    font-family: PopReg;
    font-weight: unset;
    transition: var(--trTime);

    &.ant-select-multiple {
      padding:0;
    }

    .ant-select-selector {
      background: transparent;
      border: none;
      padding: 0;
      height: unset;
      border-radius: 0;
    }
  }

  .input-text {
    padding: var(--inputTextPadding);
    border: 2px solid var(--lightGrey);
    border-radius: 12px;
    background: none;
    color: var(--black);
    --webkit-appearance: none;
    font-size: var(--const14);
    font-family: PopReg;
    font-weight: unset;
    transition: var(--trTime);


    &::placeholer {
      color: var(--grey);
    }

    &:hover {
      border: 2px solid var(--grey) !important;
    }

    &:focus {
      caret-color: var(--purple);
      border: 2px solid var(--purple) !important;
      box-shadow: none;
    }

    &.error {
      border: 2px solid var(--red) !important;
      color: var(--red);
    }
  }

  .ant-form-item,
  .ant-radio-group {
    margin-bottom: var(--sp5x);
    line-height: unset;

    &.hideLabel {
      .ant-form-item-label {
        opacity: 0;
        pointer-events:none;
      }
    }
  }

  .ant-radio-group {
    display: flex;

    .ant-radio-wrapper {
      margin: 0;
      align-items: flex-start;
      margin-right: var(--sp5x);

      
      & > span:nth-child(2) {
        margin-top:3px;
      }

      .ant-radio {

        &:hover {
          .ant-radio-inner {
            border-color: var(--purple);
          }
        }

        .ant-radio-inner {
          width: 20px;
          height: 20px;

          &:after {
            top: 5px;
            left: 5px;
            display: none;
          }
        }

        &.ant-radio-checked {
          &:after {
            border-color: var(--purple);
          }

          .ant-radio-inner {
            border-color: var(--purple);
            border-width: 5px;
          }
        }
      }
    }
  }

  .halfInputs {
    justify-content: space-between;
    align-items: flex-start;
    
      &.password {
        position: relative;
        margin-bottom: var(--sp5x);
        padding-bottom: var(--sp5x);

        .ant-form-item{
          .ant-form-item-explain {
            display: none;
          }
        }
      }

      .check {
        position: absolute;
        top:100%;
        transform:translateY(-100%);

        span {
          text-align:center;

          &:not(:last-child){
            margin-right:var(--sp2x);
          }

          &.green {
            animation: active var(--trTime2) forwards 0.1s;
          }
          
          @keyframes active {
            0%,100% {
              transform: scale(1);
            }

            50% {
              transform: scale(1.25);
            }
          }
        }
      }

    &.secondLabelRight {
      .ant-form-item {
        &:nth-child(2) {
          .ant-form-item-label {
            margin-left: auto;

            label {
              color: var(--grey);
              font-size: var(--h7);
              font-family: PopReg;
            }
          }
        }
      }
    }

    .ant-form-item {
      width: calc(50% - var(--sp2x));
      font-size: inherit !important;
      line-height: inherit !important;
      margin-bottom: var(--sp5x);
    }
  }

  .register-form {
    .location-select {
      .ant-select {
        .ant-select-selector {
           text-indent:var(--sp3x);
          
           .ant-select-selection-search {
            position: relative;
            height: 21px;
            right: unset;
            left: unset;
            
            input {
              height: 21px;
            }
          }

          .ant-select-selection-placeholder,
          .ant-select-selection-item{
            position: absolute;
            left: 0;
          }
        }
      }
    }

    .buttons-block {
      width: 100%;
      justify-content: space-between;
    }

    .social-link {
      .cont {
        align-items:flex-start;

        &:nth-child(1){
          i {
            margin-top:68px;
            @media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}){
              margin-top:57px;
              
            }
          }

          .ant-row {
            .ant-form-item-label {
              transform:translateX(-36px);
            }
          }

        }

        i {
          margin-top:19px;
          margin-right: var(--sp2x);
          font-size: var(--sp2-5x);

          &:before {
            color:var(--grey);
          }
        }

        .ant-form-item {
          flex:1;
        }
      }
    }
  }

  .edit-form {

    .location-select {
      .ant-select {
        .ant-select-selector {
            text-indent:var(--sp3x);
          
            .ant-select-selection-search {
                position: relative;
                height: 21px;
                right: unset;
                left: unset;
          
            input {
               height: 21px;
            }
          }

          .ant-select-selection-placeholder,
          .ant-select-selection-item{
            position: absolute;
            left: 0;
          }
        }
      }
    }

    .input-text {
      &.ant-input-textarea {
        padding:0;
  
        &:after {
          margin-top:8px;
        }
  
        textarea {
          border:none;
          border-radius: 12px;
          outline:none;
          padding:var(--inputTextPadding);
  
          &:focus {
            caret-color: var(--purple);
            border:none !important;
            box-shadow: unset;
          }
        }
      }
    }
    
    .buttons {
      margin-top:var(--sp2x);
    }
    .social-link {
      .cont {
        align-items:flex-start;

        &:nth-child(1){
          i {
            margin-top:68px;
            @media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}){
              margin-top:57px;
              
            }
          }

          .ant-row {
            .ant-form-item-label {
              transform:translateX(-36px);
            }
          }

        }

        i {
          margin-top:19px;
          margin-right: var(--sp2x);
          font-size: var(--sp2-5x);

          &:before {
            color:var(--grey);
          }
        }

        .ant-form-item {
          flex:1;
          margin-bottom:var(--sp3x);
        }
      }
    }
  }

  .register-form, .debate-form {
    max-width: var(--sp80x);
    margin: var(--sp8x) auto var(--sp10x);
    width: 100%;

    .input-text {
      &.ant-input-textarea {
        padding:0;
  
        &:after {
          margin-top:8px;
        }
  
        textarea {
          border:none;
          border-radius: 12px;
          outline:none;
          padding:var(--inputTextPadding);
  
          &:focus {
            caret-color: var(--purple);
            border:none !important;
            box-shadow: unset;
          }
        }
      }
    }

    .step-indicator {
      width: var(--sp37x);
      display: flex;
      justify-content: space-between;
      align-self: center;
      margin: var(--sp3x) 0 var(--sp10x);
      position: relative;

      .step {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        border: 2px solid #B5B5B5;
        background-color: var(--white);
        transition: var(--trTime);

        &:not(:last-child) {
          &:before {
            content: '';
            position: absolute;
            top: 50%;
            left: 28px;
            width: calc(100% - var(--sp7x));
            height: 2px;
            background-color: #B5B5B5;
          }
        }

        .num {
          font-size: 14px;
          color: #B5B5B5;
        }

        .title {
          color: #B5B5B5;
        }

        &.step-1 {
          .title {
            position: absolute;
            top: calc(100% + var(--spSize));
            left: 0;
            transform: translateX(-20%);
          }
        }

        &.step-2 {

          .title {
            position: absolute;
            top: calc(100% + var(--spSize));
            right: 0;
            transform: translateX(20%);
          }
        }

        &.done {
          background-color: var(--purple);
          border-color: var(--purple);

          .title {
            color: var(--purple);
          }

          i {
            &:before {
              color: var(--white);
            }
          }

          &:before {
            background-color: var(--purple);
          }
        }

        &.active {
          border-color: var(--purple);


          .num {
            color: var(--purple);
          }

          .title {
            color: var(--black);
          }
        }
      }
    }

    .social-link {
      .ant-form-item {
        &:not(:last-child) {
          margin-bottom: var(--sp2x);
        }
      }
    }

    .title {
      margin-bottom: var(--sp5x);
    }

    .line {
      width: 100%;
      height: 1px;
      background-color: var(--lightGrey);
      display: inline-block;

    }

    .submit-reg-btn {
      margin-top: var(--sp5x);
    }

    .buttons-block {
      margin-top: var(--sp5x);
      align-self: flex-end;

      .submit-reg-btn {
        margin-top: 0;
        margin-left: var(--sp2-5x);
      }
    }
  }

  //! Select box style

  .ant-select-dropdown {
    .ant-select-item  {
      padding:var(--sp2x);
      border-bottom: 1px solid var(--lightGrey);
      background-color: inherit;
      font-weight:unset;


      .ant-select-item-option-content {
        font-family: PopReg;
        display: flex;
        align-items: center;

        .flag {
          margin-right: var(--sp2x);
          width: 30px;
          height: 20px;
        }

        .info {
          margin-left:auto;
          margin-right:var(--sp2x);
        }

        .invite-list {
            width:100%;
            padding:var(--sp2x);
            color:var(--black);
            .single-user {
                    align-items:center;
                    .imageCont{
                        width:var(--sp4x) ;
                        padding-top:var(--sp4x) ;
                        border-radius:var(--spSize);
                        overflow:hidden ;
                        margin-right:var(--sp2x);
                    }
                    &:first-child {
                        padding-bottom:var(--sp2-5x);
                    }
                    &:last-child {
                        padding-bottom:0 !important;
                    }
                    &:not(:first-child){
                        border-top:1px solid var(--lightGrey);
                        padding:var(--sp2-5x) 0;
                    }
                    .op-close {
                        margin-left:auto;
                        font-size:var(--spSize);
                    }
            }
    }
      }

      &.ant-select-item-option-active {
        .ant-select-item-option-content {
          color:var(--purple);
          font-family: PopSemi;
        }
      }

      .ant-select-item-option-state {
        .imageCont {
          width: 14px;
          padding-top: 14px;

          img {
            object-fit: contain;
          }
        }
      }
    }

    &.viewers {
          background-color:#FFF8F2 ;
          padding:0;

        .ant-select-item {
            padding:0;
            align-items:center;

            .imageCont{
                    width:15px;
                    padding-top:var(--sp4x);
                    margin-right:var(--sp2x);
             }
        }
      }
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border:none !important;
    box-shadow: unset;
  }

  .ant-select {
    .ant-select-arrow {
      position: absolute;
      top: 50%;
      right: 24px;
      margin-top: 0;
      transform: translateY(-50%);
    }

    &.ant-select-multiple {
      .ant-select-selector {
        flex: auto;
        padding: 0 !important;
        min-height: var(--sp6-5x);

        .ant-select-selection-item {
          color: var(--black);
          margin: var(--spSize) var(--sp2x) var(--spSize) var(--spSize) !important;
          height: auto;
          border-radius: 5px;
          padding: calc(var(--spSize) - 2px) var(--spSize) !important;

          .flag {
            margin-right: var(--sp2x);
            width: 30px;
            height: 20px;
          }
          
          .ant-select-selection-item-content {
            margin-right: var(--sp2x);
            line-height: 1;
            display:flex;

            .info {
              margin-left:var(--spSize);
            }
          }

          .ant-select-selection-item-remove {
            display: flex;
            align-items: center;

            .anticon-close {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }

    &.viewersWrapper {

        .ant-select-selection-item {
            background-color:#FFF8F2 ;
            border:none;
            border-radius:12px;
        }
        .invite-list {
          
        .single-user {
          align-items:center;

        .imageCont{
          width:var(--sp4x) ;
          padding-top:var(--sp4x) ;
          border-radius:var(--spSize);
          overflow:hidden ;
          margin-right:var(--sp2x);
        }

        &:first-child {
          padding-bottom:var(--sp2-5x);
        }

        &:last-child {
          padding-bottom:0 !important;
        }

        &:not(:first-child){
          border-top:1px solid var(--lightGrey);
          padding:var(--sp2-5x) 0;
        }

        .op-close {
          margin-left:auto;
          font-size:var(--spSize);
        }
        }
        }
    }
  }

  .ant-select-single {
    &:not(.ant-select-customize-input) .ant-select-selector::after {
      content: none;
    }
  }

  .ant-select-clear {
    display: none;
  }

  .ant-select-selection-item {
    background-color: var(--white);
    font-family: PopReg;
    color: var(--black);
    font-size: var(--const14);
    line-height: normal !important;
    padding-right: var(--sp3x);
    display: flex;
    align-items: center;

    .flag {
      margin-right: var(--sp2x);
      width: 30px;
      height: 20px;
    }
  }

  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    background-color: var(--white);
    font-family: PopReg;
    color: var(--grey);
    font-size: var(--const14);
    line-height: normal;

    &:after {
      height: 0;
    }
  }

  @media screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
    
    //! Form inputs
    .ant-form-item-label {
      margin-bottom: var(--sp2x);
    }

    .ant-form-item {
      margin-bottom: var(--sp3x);
    }


    .edit-form {
      .social-link {
        .cont {
          .ant-form-item {
            margin-bottom:var(--sp2x);
          }
        }
      }
    }
    
    .halfInputs {
      width: 100%;
      flex-direction: column;
      align-items: stretch;
      position: relative;

      &.secondLabelRight {
        .ant-form-item {
          &:nth-child(2) {
            .ant-form-item-label {
              position: absolute;
              top: 0;
              right: 0;
            }
          }
        }
      }

      .ant-form-item {
        width: 100%;
        margin-bottom: var(--sp3x);

        &.hideLabel {
          .ant-form-item-label {
            display: none;
          }
        }
      }
    }

    .debate-form {
			.ant-radio-group {
				flex-direction:column;

        .ant-radio-wrapper {
          margin-right:0;

          &:not(:first-child){
            margin-top:var(--sp3x);
          }
        }
			}
    }

    .register-form, .debate-form {
      padding: 0 var(--sp2x);
      max-width: unset;
      margin: var(--sp2x) auto var(--sp4x);

      .step-indicator {
        width: var(--sp37x);
        margin: var(--sp3x) 0 var(--sp10x);
      }

      .social-link {
        .ant-form-item {
          &:not(:last-child) {
            margin-bottom: var(--sp2x);
          }
        }
      }

      .title {
        margin-bottom: var(--sp3x);
      }


      .submit-reg-btn {
        margin-top: var(--sp3x);
      }

      .buttons-block {
        margin-top: var(--sp3x);

        .submit-reg-btn {
          margin-left: var(--sp2-5x);
        }
      }
    }
  }
`

export default FormStyle